import PropTypes from 'prop-types';

function SvgRipley({ height, width }) {
  return (
    <svg
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 89.29 128.82"
      fill="black"
    >
      <title>r.com_2017</title>
      <path d="M89.27,95.24c0-.63-.8-.82-.8-.82-8-1.48-15.47-7.05-21.12-13a138.74,138.74,0,0,1-20-27.73c-.89-2.07.38-2.29.38-2.29v0c15.59-6,18.16-21.57,18.16-25.83C65.87,5.83,47.19,0,30.35,0,24,0,21.87.53,15.25.53,7.55.53,2.92,0,1.73,0A1.82,1.82,0,0,0,0,2C0,6.76,10.87-1.33,10.87,14.58V78.06C10.87,92.77.53,88.67.53,92.25c0,1.2,1.32,1.59,2.11,1.59,3.85,0,8.22-.53,14.45-.53,7.83,0,9.81.53,14.32.53,3.31,0,3.84-.66,3.84-1.59,0-4.5-13.91,2.39-13.91-16.7V8.62c0-4,2.92-4,7.16-4,15.24,0,27.3,8.49,27.56,24.52.18,10.87-8,21.19-21.47,21.19a23.53,23.53,0,0,1-4.78-.28c-.66,0-1.33.27-1.33,1.19,0,1.21,1,1.84,2.13,2.17,1.49.65,4.9,1.19,8.45,6.65h0c9,14.8,19.2,37,42.39,37,8.68,0,7.8-1,7.8-1.82" />
      <path d="M1.45,124.85a4,4,0,1,1,4,4A4,4,0,0,1,1.45,124.85Z" />
      <path d="M10.83,117.8a10.81,10.81,0,0,1,11.05-11,10.74,10.74,0,0,1,9.43,5.34l-5.46,3.17a4.32,4.32,0,0,0-4-2.34,4.84,4.84,0,0,0,0,9.68,4.28,4.28,0,0,0,4-2.34l5.46,3.13a10.65,10.65,0,0,1-9.43,5.38A10.81,10.81,0,0,1,10.83,117.8Z" />
      <path d="M32.35,117.8a11.06,11.06,0,1,1,11.05,11A10.93,10.93,0,0,1,32.35,117.8Zm15.85,0a4.8,4.8,0,1,0-4.8,4.92A4.68,4.68,0,0,0,48.21,117.8Z" />
      <path d="M89.29,115.43v12.81H83V116c0-2.09-1-3.42-3-3.42s-3.25,1.46-3.25,3.92v11.76H70.52V116c0-2.09-1-3.42-3-3.42s-3.25,1.46-3.25,3.92v11.76H58V107.37h6.26v1.92c1-1.42,2.79-2.5,5.59-2.5a6.21,6.21,0,0,1,5.46,2.75c1.17-1.67,3.09-2.75,6-2.75C86.17,106.79,89.29,110.21,89.29,115.43Z" />
    </svg>
  );
}

SvgRipley.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

SvgRipley.defaultProps = {
  height: 46,
  width: 31.885,
};

export default SvgRipley;
